import 'bootstrap';

import Log from '~/_Utility/Log';

class Bootstrap {

    /**
     * @since 2.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.0.0
     * @return void
     */
    init() {
        // Probably listen for the masonry thing here
        new Log('Bootstrap initialized.', 'init');

        // Register tooltip options
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body',
            offset:    0,
        });

        // Initialize popovers
        $('[data-toggle="popover"]').popover();

        // Prevent conflicts with WP media gallery
        $('.modal').on('show.bs.modal', function (e) {

            // Pop up that class when we open the modal
            $('body').addClass('p3-modal-open');

        }).on('hidden.bs.modal', function (e) {

            // Remove when the modal closes
            $('body').removeClass('p3-modal-open');

        });

        // Make toast
        $('.toast').each(function (e) {

            // Yeah! Toast!
            $(this).toast('show');

        });

    }
}

export default Bootstrap;